import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { RoleService } from '../services/role.service';

@Injectable()
export class RoleGuard implements CanActivate {

    constructor(public auth: AuthGuard, 
        public router: Router,
        public roleService: RoleService,
    ) {}
    
    canActivate(route: ActivatedRouteSnapshot): boolean {

        if (!this.roleService.hasRoles(route.data.roles)) {
            this.router.navigate(['access-denied']);

            return false;
        }
        return true;
    }
}
